import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/About';
import Contact from '../pages/Contact';
import Development from '../pages/services/development';
import Graphics from '../pages/services/graphics';
import UIUX from '../pages/services/uiux';
import Constructions from '../pages/services/constructions';
import MIS from '../pages/services/mis';
import CRM from '../pages/products/crm';
import ERP from '../pages/products/erp';
import FrontendDevelopment from '../pages/services/development/frontend';
import BackendDevelopment from '../pages/services/development/backend';
import FullstackDevelopment from '../pages/services/development/fullstack';
import EcommerceDevelopment from '../pages/services/development/ecommerce';
import MobileAppDevelopment from '../pages/services/development/mobileapp';
import BrandingDesign from '../pages/services/graphics/branding';
import LogoDesign from '../pages/services/graphics/logo';
import PrintDesign from '../pages/services/graphics/print';
import SocialDesign from '../pages/services/graphics/social';
import WireframingPage from '../pages/services/uiux/wireframing';
import PrototypingPage from '../pages/services/uiux/prototyping';
import UsabilityPage from '../pages/services/uiux/usability';
import DesignSystemPage from '../pages/services/uiux/designsystem';
import InteractionDesignPage from '../pages/services/uiux/interaction';
import ConstructionPlanningPage from '../pages/services/constructions/planning';
import EstimationPage from '../pages/services/constructions/estimation';
import AritechPage from '../pages/services/constructions/aritech';
import SiteManagementPage from '../pages/services/constructions/sitemanagement';
import ConsultancyPage from '../pages/services/constructions/consultancy';
import ReportingPage from '../pages/services/mis/reporting';
import MISDashboardPage from '../pages/services/mis/dashboard';
import AutomationPage from '../pages/services/mis/automation';
import DataEntryPage from '../pages/services/mis/dataentry';
import AnalyticsPage from '../pages/services/mis/analytics';
import NotFound from '../pages/NotFound';
import Marketing from '../pages/services/marketing';
import MarketingSEOPage from '../pages/services/marketing/seo';
import SocialMarketingPage from '../pages/services/marketing/social';
import EmailMarketingPage from '../pages/services/marketing/email';
import ContentMarketingPage from '../pages/services/marketing/content';
import InfluencerMarketingPage from '../pages/services/marketing/influencer';
import AnalyticsMarketingPage from '../pages/services/marketing/analytics';
import UIPage from '../pages/services/uiux/ui';


const AppRouter = () => {
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />

      {/* Services */}
      <Route path="/services/development" element={<Development />} />
      <Route path="/services/graphics" element={<Graphics />} />
      <Route path="/services/uiux" element={<UIUX />} />
      <Route path="/services/constructions" element={<Constructions />} />
      <Route path="/services/mis" element={<MIS />} />
      <Route path="/services/marketing" element={<Marketing />} />

      {/* Development */}
      <Route path="/services/development/frontend" element={<FrontendDevelopment />} />
      <Route path="/services/development/backend" element={<BackendDevelopment />} />
      <Route path="/services/development/fullstack" element={<FullstackDevelopment />} />
      <Route path="/services/development/ecommerce" element={<EcommerceDevelopment />} />
      <Route path="/services/development/mobileapp" element={<MobileAppDevelopment />} />

      {/* Graphics */}
      <Route path="/services/graphics/branding" element={<BrandingDesign />} />
      <Route path="/services/graphics/logo" element={<LogoDesign />} />
      <Route path="/services/graphics/print" element={<PrintDesign />} />
      <Route path="/services/graphics/social" element={<SocialDesign />} />

       {/* UIUX */}
      <Route path="/services/uiux/wireframing" element={<WireframingPage />} />
      <Route path="/services/uiux/prototyping" element={<PrototypingPage />} />
      <Route path="/services/uiux/usability" element={<UsabilityPage />} />
      <Route path="/services/uiux/designsystem" element={<DesignSystemPage />} />
      <Route path="/services/uiux/interaction" element={<InteractionDesignPage />} />
      <Route path="/services/uiux/ui" element={<UIPage />} />

       {/* Constructions */}
      <Route path="/services/constructions/planning" element={<ConstructionPlanningPage />} />
      <Route path="/services/constructions/estimation" element={<EstimationPage />} />
      <Route path="/services/constructions/aritech" element={<AritechPage />} />
      <Route path="/services/constructions/sitemanagement" element={<SiteManagementPage />} />
      <Route path="/services/constructions/consultancy" element={<ConsultancyPage />} />

       {/* MIS */}
      <Route path="/services/mis/reporting" element={<ReportingPage />} />
      <Route path="/services/mis/dashboard" element={<MISDashboardPage />} />
      <Route path="/services/mis/automation" element={<AutomationPage />} />
      <Route path="/services/mis/dataentry" element={<DataEntryPage />} />
      <Route path="/services/mis/analytics" element={<AnalyticsPage />} />

      {/* Marketing */}
      <Route path="/services/marketing/seo" element={<MarketingSEOPage />} />
      <Route path="/services/marketing/social" element={<SocialMarketingPage />} />
      <Route path="/services/marketing/email" element={<EmailMarketingPage />} />
      <Route path="/services/marketing/content" element={<ContentMarketingPage />} />
      <Route path="/services/marketing/influencer" element={<InfluencerMarketingPage />} /> 
      <Route path="/services/marketing/analytics" element={<AnalyticsMarketingPage />} />

      {/* Products */}
      <Route path="/products/crm" element={<CRM />} />
      <Route path="/products/erp" element={<ERP />} />

      {/* Catch-all 404 route LAST */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;


